<div class="media-content-container" [ngStyle]="containerStyle">
  <ng-container *ngIf="canOpenPhoto; else canNotOpenPhoto">
    <app-no-photo
      *ngIf="showNoPhoto"
      [isMainPhoto]="true">
    </app-no-photo>
    <app-main-image
      *ngIf="showMainPhoto"
      [imageId]="imageList[0] || mainPhoto"
      [imageWidth]="mediaContainerWidth"
      [imageHeight]="mediaContainerHeight">
    </app-main-image>
    <ng-container *ngIf="videoSource">
      <div class="main-frame" [ngStyle]="{ width: mediaContainerWidth, height: mediaContainerHeight}">
        <app-video-player
          [source]="videoSource"
          [playVideo]="playVideo"
          [id]="videoElementId"
          [prefix]="prefix">
        </app-video-player>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #canNotOpenPhoto>
    <app-no-photo
      [class.only-photo]="showOnlyPhoto"
      *ngIf="showNoPhoto"
      [isMainPhoto]="true">
    </app-no-photo>
    <app-main-image
      *ngIf="showMainPhoto"
      [imageId]="imageList[0] || mainPhoto"
      [img]="mainPhoto"
      (errorImg)="onError()"
      [borderRadius]="showOnlyPhoto && 15"
      [imageWidth]="mediaContainerWidth"
      [imageHeight]="mediaContainerHeight">
    </app-main-image>
    <ng-container *ngIf="videoSource && !showOnlyPhoto">
      <div class="main-frame" [ngStyle]="{ width: mediaContainerWidth, height: mediaContainerHeight}">
        <app-video-player
          [source]="videoSource"
          [playVideo]="playVideo"
          [id]="videoElementId"
          [prefix]="prefix">
        </app-video-player>
      </div>
    </ng-container>
  </ng-template>
  <ng-container *ngIf="reserved">
    <img class="reserved" src="assets/images/reserved-tile.png" alt="reserved">
  </ng-container>
</div>
